// @ts-nocheck
import React from 'react';
// import { mergeclassNameNames } from '../../utils';
// import ContactFormView from '../ContactFormView';
// import styles from './index.module.scss';

export default function HeaderWebex() {
  return (
    <div className="wx-wrapper navigation-wrapper">
      <div className="header_headerWrapper__30NyQ header_scrollUp__3QV5h">
        <div className="header_overlay__2h1yB"></div>
        <header className="header_header__12jgZ header_fastClose__1Go-F">
          <section className="header_banner__2BrOE">
            <div className="container">
              <div className="grid">
                <div className="col">
                  <ul className="header_list__1f0QB">
                    <li>
                      <a href="https://www.webex.com/downloads.html" tabindex="0">
                        Download
                      </a>
                    </li>
                    <li>
                      <a href="https://help.webex.com/contact" target="_blank" tabindex="0">
                        Support
                      </a>
                    </li>
                    <li>
                      <a href="https://www.webex.com/contact-sales.html" tabindex="0">
                        Contact Sales
                      </a>
                    </li>
                    <li>
                      <span className="xsbody header_phone__CWCpv" aria-label="1. 8 8 8. 4 6 9. 3 2 3 9.">
                        <a href="tel:+1-888-469-3239">+1-888-469-3239</a>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <section className="header_wrapper__OpVK9">
            <div className="container">
              <div className="header_wrapperInner__2aEot">
                <a href="/" className="header_logo__21HnF">
                  <h1 className="h1 header_h1__144Es header_blackLogo__tSzjc" role="heading" aria-level="1">
                    <div>
                      <img className="img100p" src="/webex/images/black.png" alt="Webex" />
                      <span>Webex</span>
                    </div>
                  </h1>
                  <h1 className="h1 header_h1__144Es header_whiteLogo__3V9L4" role="heading" aria-level="1">
                    <div>
                      <img className="img100p" src="/webex/images/white.png" alt="Webex" />
                      <span>Webex</span>
                    </div>
                  </h1>
                </a>
                <button type="button" className="header_openedMenu__1_VVm">
                  <span></span>
                  <span></span>
                </button>
                <nav className="header_navbar__2vIOU gradient-blurple-mobile">
                  <div className="header_closeDiv__ZBNqn">
                    <a href="tel:1-888-469-3239" className="xsbody black-font" aria-label="1. 8 8 8. 4 6 9. 3 2 3 9.">
                      +1-888-469-3239
                    </a>
                    <button type="button" className="header_closedMenu__LcJ3R">
                      <span>
                        <span className="icon-close"></span>
                      </span>
                    </button>
                  </div>
                  <ul className="header_menu__TYJcK header_firstMenu__2IC4J">
                    <li className="header_menuItem__cnNBL header_mobileBtn__3w30I">
                      <button id="openCartPage" className="btn btn-contact">
                        Start For Free
                      </button>
                      <button id="openContactSalesPage" className="btn btn-secondary-dark">
                        Contact Sales
                      </button>
                    </li>
                    <li className="header_menuItem__cnNBL header_menuItemHasChildren__bCODH header_mobFirst__26Ijl">
                      <a href="#" data-toggle="sub-menu">
                        Products <i className="icon-open header_expand__1bvc0"></i>
                      </a>
                      <ul className="header_subMenu__WoVAg bg-white gradient-blurple-desktop">
                        <div className="header_dropdownMenu__3DtqE">
                          <div className="container">
                            <div className="grid">
                              <div className="col col-3 col-sm">
                                <div className="header_areaTitle__uG4p3 mb-20">
                                  <p className="sbody fw-medium">For Personal &amp; Small Business</p>
                                </div>
                                <div className="header_dropdownItem__2eX_2">
                                  <div className="header_dropdownItemTop__3g0Q0">
                                    <div className="header_dropdownItemTitle__3SOAl">
                                      <h6 class="webex-app-desktop">
                                        <a>
                                          Webex App<span class="icon-open header_mobileArrow__2s7Bj"></span>
                                        </a>
                                      </h6>
                                      <h6 class="webex-app-mobile">
                                        <a href="https://www.webex.com/all-new-webex.html">
                                          Webex App<span class="icon-open header_mobileArrow__2s7Bj"></span>
                                        </a>
                                      </h6>
                                    </div>
                                    <div className="header_dropdownItemDesc__23wtb">
                                      <p className="sbody color-boulder">
                                        The all-in-one app to call, meet, message, and get work done.
                                      </p>
                                    </div>
                                    <div className="header_ctaBox__3kCvW">
                                      <a
                                        href="https://www.webex.com/all-new-webex.html"
                                        tabindex="0"
                                        className="fw-medium color-salem"
                                      >
                                        Explore the App <span className="icon-arrow"></span>
                                      </a>
                                    </div>
                                  </div>
                                  <ul className="mbody">
                                    <li>
                                      <a href="https://www.webex.com/cloud-calling.html" tabindex="0">
                                        Calling<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                      </a>
                                    </li>
                                    <li>
                                      <a href="https://www.webex.com/video-conferencing.html" tabindex="0">
                                        Meetings<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                      </a>
                                    </li>
                                    <li>
                                      <a href="https://www.webex.com/team-collaboration.html" tabindex="0">
                                        Messaging<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                              <div className="col col-9 col-sm">
                                <div className="header_areaTitle__uG4p3 header_areaTitleSec__2XOJE mb-20">
                                  <p className="sbody fw-medium">For Enterprise</p>
                                </div>
                                <div className="grid">
                                  <div className="col col-4 col-sm">
                                    <div className="header_dropdownItem__2eX_2 header_dropdownItemBorder__2BhFB">
                                      <div className="header_dropdownItemTop__3g0Q0">
                                        <div className="header_dropdownItemTitle__3SOAl">
                                          <h6 class="webex-suite-desktop">
                                            <a>
                                              Webex Suite<span class="icon-open header_mobileArrow__2s7Bj"></span>
                                            </a>
                                          </h6>
                                          <h6 class="webex-suite-mobile">
                                            <a href="https://www.webex.com/collaboration-suite.html">
                                              Webex Suite<span class="icon-open header_mobileArrow__2s7Bj"></span>
                                            </a>
                                          </h6>
                                        </div>
                                        <div className="header_dropdownItemDesc__23wtb">
                                          <p className="sbody color-boulder">
                                            The first best-of-breed suite for hybrid work.
                                          </p>
                                        </div>
                                        <div className="header_ctaBox__3kCvW">
                                          <a
                                            href="https://www.webex.com/collaboration-suite.html"
                                            tabindex="0"
                                            className="fw-medium color-salem"
                                          >
                                            Explore the Suite <span className="icon-arrow"></span>
                                          </a>
                                        </div>
                                      </div>
                                      <ul className="mbody">
                                        <li>
                                          <a href="https://www.webex.com/enterprise-cloud-calling.html" tabindex="0">
                                            Calling<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://www.webex.com/meetings.html'" tabindex="0">
                                            Meetings<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="/team-collaboration.html" tabindex="0">
                                            Messaging<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://www.webex.com/audience-engagement.html" tabindex="0">
                                            Polling<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://www.webex.com//webinar.html" tabindex="0">
                                            Events<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div className="col col-4 col-sm">
                                    <div className="header_dropdownItem__2eX_2 header_dropdownItemBorder__2BhFB">
                                      <div className="header_dropdownItemTop__3g0Q0">
                                        <div className="header_dropdownItemTitle__3SOAl">
                                          <h6>
                                            <a>
                                              Customer Experience
                                              <span className="icon-open header_mobileArrow__2s7Bj"></span>
                                            </a>
                                          </h6>
                                        </div>
                                        <div className="header_dropdownItemDesc__23wtb">
                                          <p className="sbody color-boulder">
                                            Solutions for connecting the customer journey and creating customer delight.
                                          </p>
                                        </div>
                                      </div>
                                      <ul className="mbody">
                                        <li>
                                          <a href="https://www.webex.com/contact-center.html" tabindex="0">
                                            Contact Center<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://www.webex.com/experience-management.html" tabindex="0">
                                            Experience Management
                                            <span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="https://www.webex.com/customer-interaction-management.html"
                                            tabindex="0"
                                          >
                                            imimobile<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div className="col col-4 col-sm">
                                    <div className="header_dropdownItem__2eX_2">
                                      <div className="header_dropdownItemTop__3g0Q0">
                                        <div className="header_dropdownItemTitle__3SOAl">
                                          <h6>
                                            <a>
                                              Management<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                            </a>
                                          </h6>
                                        </div>
                                        <div className="header_dropdownItemDesc__23wtb">
                                          <p className="sbody color-boulder">
                                            Enterprise-grade security, administration and management of Webex.
                                          </p>
                                        </div>
                                      </div>
                                      <ul className="mbody">
                                        <li>
                                          <a href="https://www.webex.com/control-hub.html" tabindex="0">
                                            Control Hub<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://www.webex.com/security.html" tabindex="0">
                                            Security<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ul>
                    </li>
                    <li className="header_menuItem__cnNBL">
                      <a href="https://www.webex.com/pricing/index.html">Pricing</a>
                    </li>
                    <li className="header_menuItem__cnNBL header_menuItemHasChildren__bCODH">
                      <a href="#" data-toggle="sub-menu">
                        Devices <i className="icon-open header_expand__1bvc0"></i>
                      </a>
                      <ul className="header_subMenu__WoVAg bg-white gradient-blurple-desktop">
                        <div className="header_dropdownMenu__3DtqE">
                          <div className="container">
                            <div className="grid">
                              <div className="col col-3 col-sm">
                                <a href="/products/headsets" tabindex="0" className="header_deviceCard__15ArY">
                                  <img src="/webex/images/devicecard_1.png" alt="device image" />
                                  <h6>
                                    Headsets<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                  </h6>
                                  <p className="sbody color-boulder">
                                    Stay focused. Get outstanding audio, wherever you work.
                                  </p>
                                </a>
                              </div>
                              <div className="col col-3 col-sm">
                                <a href="/products/cameras" tabindex="0" className="header_deviceCard__15ArY">
                                  <img src="/webex/images/devicecard_2.png" alt="device image" />
                                  <h6>
                                    Cameras<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                  </h6>
                                  <p className="sbody color-boulder">
                                    Always look your best! Professional cameras, optimized for video meetings.
                                  </p>
                                </a>
                              </div>
                              <div className="col col-3 col-sm">
                                <a href="/products/desk-series" tabindex="0" className="header_deviceCard__15ArY">
                                  <img src="/webex/images/devicecard_3.png" alt="device image" />
                                  <h6>
                                    Desk Series<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                  </h6>
                                  <p className="sbody color-boulder">
                                    Call, meet, co-create and more. Intelligent collaboration devices for every desk.
                                  </p>
                                </a>
                              </div>
                              <div className="col col-3 col-sm">
                                <a
                                  href="/products/room-series-and-kits"
                                  tabindex="0"
                                  className="header_deviceCard__15ArY"
                                >
                                  <img src="/webex/images/devicecard_4.png" alt="device image" />
                                  <h6>
                                    Room Series<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                  </h6>
                                  <p className="sbody color-boulder">
                                    Eliminate distance. Video bars and smart multi-screen video conferencing for every
                                    workspace.
                                  </p>
                                </a>
                              </div>
                              <div className="col col-3 col-sm">
                                <a href="/products/board-series" tabindex="0" className="header_deviceCard__15ArY">
                                  <img src="/webex/images/devicecard_5.png" alt="device image" />
                                  <h6>
                                    Board Series<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                  </h6>
                                  <p className="sbody color-boulder">
                                    Let teamwork thrive. All-in-one presentation displays, video conferencing, and
                                    digital whiteboards.
                                  </p>
                                </a>
                              </div>
                              <div className="col col-3 col-sm">
                                <a href="/products/phones" tabindex="0" className="header_deviceCard__15ArY">
                                  <img src="/webex/images/devicecard_6.png" alt="device image" />
                                  <h6>
                                    Phone Series<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                  </h6>
                                  <p className="sbody color-boulder">
                                    Make every call count. Business-className phones for the desk, the frontline, and
                                    everywhere between.
                                  </p>
                                </a>
                              </div>
                              <div className="col col-3 col-sm">
                                <a href="/products/accessories" tabindex="0" className="header_deviceCard__15ArY">
                                  <img src="/webex/images/devicecard_7.png" alt="device image" />
                                  <h6>
                                    Accessories<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                  </h6>
                                  <p className="sbody color-boulder">
                                    Enhance your workplace. Panels for booking rooms, advanced microphones, and more.
                                  </p>
                                </a>
                              </div>
                              <div className="col col-3 col-sm">
                                <a
                                  href="https://www.webex.com/collaboration-devices.html"
                                  tabindex="0"
                                  className="header_allDeviceCard__WPtZy"
                                >
                                  <span className="btn btn-round-icon btn-round-icon color-white">
                                    View All Devices<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                    <span className="icon-arrow bg-white color-black"></span>
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ul>
                    </li>
                    <li className="header_menuItem__cnNBL header_menuItemHasChildren__bCODH">
                      <a href="#" data-toggle="sub-menu">
                        Solutions <i className="icon-open header_expand__1bvc0"></i>
                      </a>
                      <ul className="header_subMenu__WoVAg  bg-white gradient-blurple-desktop">
                        <div className="header_dropdownMenu__3DtqE">
                          <div className="container">
                            <div className="grid">
                              <div className="col col-6 col-sm">
                                <div className="grid header_solutionLeft__2XR9c">
                                  <div className="col col-6 col-sm">
                                    <div className="header_solutionLinkList__3Jujs">
                                      <div className="header_solutionListTitle__2EOGR">
                                        <h6>Industry</h6>
                                      </div>
                                      <ul className="header_solutionList__3yIOq">
                                        <li>
                                          <a href="https://www.webex.com/industries/education.html" tabindex="0">
                                            Education<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://www.webex.com/industries/healthcare.html" tabindex="0">
                                            Healthcare<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://www.webex.com/industries/government.html" tabindex="0">
                                            Government<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="https://www.webex.com/industries/financial-services.html"
                                            tabindex="0"
                                          >
                                            Finance<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="https://www.webex.com/industries/sports-entertainment.html"
                                            tabindex="0"
                                          >
                                            Sports &amp; Entertainment
                                            <span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://www.webex.com/industries/start-ups.html" tabindex="0">
                                            Startups<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div className="col col-6 col-sm">
                                    <div className="header_solutionLinkList__3Jujs">
                                      <div className="header_solutionListTitle__2EOGR">
                                        <h6>Workspaces</h6>
                                      </div>
                                      <ul className="header_solutionList__3yIOq">
                                        <li>
                                          <a href="https://hardware.webex.com/workspaces/personal-offices" tabindex="0">
                                            Personal Spaces<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://hardware.webex.com/workspaces/huddle" tabindex="0">
                                            Huddle Spaces<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://hardware.webex.com/workspaces/co-creation" tabindex="0">
                                            Co-Creation<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://hardware.webex.com/workspaces/meeting" tabindex="0">
                                            Meeting Rooms<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="https://hardware.webex.com/workspaces/special-purpose-rooms"
                                            tabindex="0"
                                          >
                                            Special Purpose Rooms
                                            <span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col col-6 col-sm">
                                <a
                                  href="https://www.webex.com/hybrid-work.html"
                                  taborder="0"
                                  className="grid header_solutionCard__XQC9y"
                                >
                                  <div className="col col-6 col-sm header_solutionCardLeft__2Z7Pk">
                                    <div className="header_solutionCardTitle__1G5NW">
                                      <h6>
                                        Hybrid Work<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                      </h6>
                                    </div>
                                    <div className="header_solutionCardDesc__20YXZ">
                                      <p className="sbody color-boulder">
                                        Webex powers a new way of collaborating that’s centered around the work you do,
                                        not where you do it.
                                      </p>
                                    </div>
                                    <div className="header_solutionCta__2JiaQ">
                                      <span className="fw-medium color-salem">
                                        Learn More<span className="icon-arrow"></span>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col col-6 col-sm header_solutionCardRight__q1GZM inherit-width">
                                    <div className="header_solutionCardImageBig__2P0uY">
                                      <img src="/webex/images/c92af18cf37e21677f4e2f8.png" alt="device image" />
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ul>
                    </li>
                    <li className="header_menuItem__cnNBL header_menuItemHasChildren__bCODH">
                      <a href="#" data-toggle="sub-menu">
                        Resources <i className="icon-open header_expand__1bvc0"></i>
                      </a>
                      <ul className="header_subMenu__WoVAg bg-white gradient-blurple-desktop">
                        <div className="header_dropdownMenu__3DtqE">
                          <div className="container">
                            <div className="grid">
                              <div className="col col-6 col-sm">
                                <div className="grid header_solutionLeft__2XR9c">
                                  <div className="col col-6 col-sm">
                                    <div className="header_solutionLinkList__3Jujs">
                                      <div className="header_solutionListTitle__2EOGR">
                                        <h6>Why Webex</h6>
                                      </div>
                                      <ul className="header_solutionList__3yIOq">
                                        <li>
                                          <a href="https://www.webex.com/inclusive-collaboration.html" tabindex="0">
                                            Inclusivity<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://www.webex.com/accessibility.html" tabindex="0">
                                            Accessibility<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a href="https://www.webex.com/security.html" tabindex="0">
                                            Security<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div className="col col-6 col-sm">
                                    <div className="header_solutionLinkList__3Jujs">
                                      <div className="header_solutionListTitle__2EOGR">
                                        <h6>Learn</h6>
                                      </div>
                                      <ul className="header_solutionList__3yIOq">
                                        <li>
                                          <a href="https://help.webex.com" target="_blank" tabindex="0">
                                            Product Help<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="https://www.webex.com/learn/webinars-demos.html"
                                            target="_blank"
                                            tabindex="0"
                                          >
                                            Webinars &amp; Daily Demos
                                            <span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="https://help.webex.com/landing/onlineclassNamees/upcomingclassName/Working-Remotely"
                                            target="_blank"
                                            tabindex="0"
                                          >
                                            Online classes<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="https://community.cisco.com/t5/webex-user-community/ct-p/webex-user"
                                            target="_blank"
                                            tabindex="0"
                                          >
                                            Webex Community<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col col-6 col-sm">
                                <a
                                  href="/products/integrations/index.html"
                                  tabindex="0"
                                  className="grid header_solutionCard__XQC9y"
                                >
                                  <div className="col col-8 col-sm header_solutionCardLeft__2Z7Pk">
                                    <div className="header_solutionCardTitle__1G5NW">
                                      <h6>
                                        Integrations<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                      </h6>
                                    </div>
                                    <div className="header_solutionCardDesc__20YXZ">
                                      <p className="sbody color-boulder">
                                        Integrate with the apps you love to
                                        <br /> use everyday.
                                      </p>
                                    </div>
                                    <div className="header_solutionCta__2JiaQ">
                                      <span className=" fw-medium color-salem">
                                        Learn More<span className="icon-arrow"></span>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col col-4 col-sm header_solutionCardRight__q1GZM inherit-width">
                                    <div className="header_solutionCardImageSmall__3YV7D">
                                      <img src="/webex/images/navi.png" alt="device image" />
                                    </div>
                                  </div>
                                </a>
                                <a
                                  href="https://blog.webex.com/"
                                  target="_blank"
                                  tabindex="0"
                                  className="grid header_solutionCard__XQC9y"
                                >
                                  <div className="col col-8 col-sm header_solutionCardLeft__2Z7Pk">
                                    <div className="header_solutionCardTitle__1G5NW">
                                      <h6>
                                        Webex Blog<span className="icon-open header_mobileArrow__2s7Bj"></span>
                                      </h6>
                                    </div>
                                    <div className="header_solutionCardDesc__20YXZ">
                                      <p className="sbody color-boulder">
                                        What’s new, tips and tricks, and <br />
                                        much more.
                                      </p>
                                    </div>
                                    <div className="header_solutionCta__2JiaQ">
                                      <span className="fw-medium color-salem">
                                        Learn More<span className="icon-arrow"></span>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="col col-4 col-sm header_solutionCardRight__q1GZM inherit-width">
                                    <div className="header_solutionCardImageSmall__3YV7D">
                                      <img src="/webex/images/c92af18cf37e21677f4e2f81.png" alt="device image" />
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ul>
                    </li>
                  </ul>
                  <ul className="header_menu__TYJcK header_secondMenu__XWyEm">
                    <li className="header_menuItem__cnNBL header_mobileBtn__3w30I">
                      <a href="https://www.webex.com /downloads.html">Download</a>
                    </li>
                    <li className="header_menuItem__cnNBL">
                      <a href="https://signin.webex.com/join">Join a Meeting</a>
                    </li>
                    <li className="header_menuItem__cnNBL header_mobileBtn__3w30I">
                      <a href="#">Support</a>
                    </li>
                    <li className="header_menuItem__cnNBL header_menuItemHasChildren__bCODH header_signInCta__1-t4e">
                      <a href="#" data-toggle="sub-menu" className="header_lastItem__2ID7v">
                        Sign In <i className="icon-open header_expand__1bvc0"></i>
                      </a>
                      <ul className="header_subMenu__WoVAg header_signInSubMenu__1QxXf">
                        <div className="header_signIn__3NImS">
                          <div className="header_signInTitle__1hbSR">
                            <h6>Sign In To Webex</h6>
                          </div>
                          <div className="header_signInInputBox__3a7_Z">
                            <label className="sbody" htmlFor="email">
                              Enter Email Address
                            </label>
                            <input type="email" id="email" name="email" required />
                            <button className="btn btn-primary" id="signin">
                              Sign In
                            </button>
                          </div>
                          <div className="header_signInCta__1-t4e">
                            <a
                              className="xsbody fw-medium"
                              href="https://help.webex.com/en-us/n5q6x5j/Sign-In-Issues-with-Webex"
                              target="_blank"
                            >
                              Need Help Signing In?
                            </a>
                          </div>
                        </div>
                      </ul>
                    </li>
                    <li className="header_menuItem__cnNBL header_deskBtn__RKPYF start-for-free">
                      <a
                        className="no-border"
                        href="https://cart.webex.com/sign-up?experienceType=Unified&ft=selfsignup&theme=dark&ft=skipProvCheck"
                        target="_blank"
                      >
                        <button className="btn header_navbarButton__3nH08">Start For Free</button>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </section>
        </header>
      </div>
    </div>
  );
}
